/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerAmazonRedshiftSourceComponent', [
    '$rootScope',
    'DesignerDatabaseBaseSourceComponent',

    function ($rootScope, DesignerDatabaseBaseSourceComponent) {
      function DesignerAmazonRedshiftSourceComponent() {
        DesignerDatabaseBaseSourceComponent.apply(this);

        this.null_string = '';
      }

      DesignerAmazonRedshiftSourceComponent.prototype = new DesignerDatabaseBaseSourceComponent();

      DesignerAmazonRedshiftSourceComponent.prototype.getData = function () {
        const data = DesignerDatabaseBaseSourceComponent.prototype.getData.call(this);

        _.extend(data, {
          null_string: this.null_string,
        });

        return data;
      };

      DesignerAmazonRedshiftSourceComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerDatabaseBaseSourceComponent.prototype.setFormData.call(this, data);
      };

      DesignerAmazonRedshiftSourceComponent.prototype.setData = function (data) {
        this.null_string = data.null_string;

        DesignerDatabaseBaseSourceComponent.prototype.setData.call(this, data);
      };

      return DesignerAmazonRedshiftSourceComponent;
    },
  ]);
})(window.angular);
